<template>
  <ListPanel :portal="portal"/>
</template>

<script>
import ListPanel from '../../../../../../../components/Administration/ContentArticleFlags/Panels/List'

export default {
  components: {ListPanel},

  props: {
    portal: {
      required: true
    }
  }
}
</script>
